import { string, object, number } from 'prop-types'
import { kuiperClassNames } from '@opallabs/kuiper'
import { colors } from '@opallabs/spectrum'
import { baseStyles } from './styles'

export const AccountName = ({
  accountHandle = '',
  color,
  name,
  noAccountColor = colors.orange.base,
  size,
  style,
}) => (
  <div
    css={baseStyles({ color, name, noAccountColor, size, style })}
    className={kuiperClassNames('account-name')}
  >
    {name ? accountHandle + name : 'No account selected'}
  </div>
)

AccountName.propTypes = {
  accountHandle: string,
  color: string,
  name: string,
  noAccountColor: string,
  size: number,
  style: object,
}
